import api from '../callApi';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const apiUpdateVoteRegistration = (
    values,
    apiRequestData,
    id,
    answerId,
    addressSource
) => {
    const addressParsedNumber = parseAddressNumber(values.Street);
    const addressParsedStreet = parseAddressStreet(values.Street);

    const request = {
        ...apiRequestData,
        id: id,
        answerId: answerId,
        email: values.email,
        dateOfBirth: values.dateOfBirth,
        usCitizen: values.usCitizen,
        hasStateLicense: values.hasStateLicense,
        name: {
            title: values.prefix,
            firstName: values.firstName,
            lastName: values.lastName,
            middleName: values.middleName,
            suffix: values.suffix
        },
        homeAddress: {
            source: addressSource,
            country: 'US',
            state: values.stateId,
            county: values.county,
            city: values.homeCity,
            zipCode: values.postalCode,
            street: addressParsedStreet,
            streetNo: addressParsedNumber,
            unit: values.unit,
            streetAddressRaw: values.homeAddress
        },
        phone: values.phone,
        sendConfirmationEmails: values.confirmationEmail,
        optInEmail: values.getUpdates,
        optInSms: values.smsUpdates
    };

    return api.post('Widget/UpdateVoteRegistrationAsync', request).then(response => {
        return response;
    });
};

export default apiUpdateVoteRegistration;



// WEBPACK FOOTER //
// ./src/utils/voteRegistration/voteRegistrationUpdateApi.js